import useWatchAuthentication from "@dpa-connect/dpa-id-user/compositions/useWatchAuthentication";
import store from "@/store";
import router from "@/router";

export default useWatchAuthentication({ store, router, appName: "audio-hub" });
